import { EmbedProvider } from "@/lib/utils/lomdaV3/types";

function extractIframeSrc(input: string): string | null {
    const match = input.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
    return match ? match[1] : null;
}

function youtubeVimeo(u: URL, value: string): string | null {
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtube.com" && u.searchParams.get("v")) {
        return `https://www.youtube.com/embed/${u.searchParams.get("v")}`;
    }
    if (host === "youtu.be") {
        return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    }
    if (host === "vimeo.com") {
        const id = u.pathname.split("/").filter(Boolean)[0];
        return id ? `https://player.vimeo.com/video/${id}` : value;
    }
    return null;
}

/** True when the URL is a YouTube/Vimeo embed player (needs an iframe, not <video>). */
export function isEmbedUrl(url: string): boolean {
    return /youtube\.com\/embed\/|player\.vimeo\.com\/video\//.test(url);
}

export function toEmbedUrl(url: string): string {
    const value = url.trim();
    const fromIframe = extractIframeSrc(value);
    if (fromIframe) return fromIframe;
    try {
        const u = new URL(value);
        return youtubeVimeo(u, value) ?? value;
    } catch {
        return value;
    }
}

export function toProviderEmbed(provider: EmbedProvider, url: string): string {
    const value = url.trim();
    const fromIframe = extractIframeSrc(value);
    if (fromIframe) return fromIframe;
    try {
        const u = new URL(value);
        const yv = youtubeVimeo(u, value);
        if (yv) return yv;
        if (provider === "canva" && u.pathname.includes("/design/")) {
            return u.search ? value : `${value.replace(/\/$/, "")}/view?embed`;
        }
        if (provider === "prezi" && /\/(p|view)\//.test(u.pathname) && !u.pathname.includes("embed")) {
            return `${value.replace(/\/$/, "")}/embed`;
        }
        return value;
    } catch {
        return value;
    }
}
